import {
  FF_CCPA_BANNER,
  FF_CCPA_COOKIE_VARIANT,
  FF_HIDE_COOKIE_WALL,
  FF_REJECT_BUTTON,
} from '@wetransfer/transfer/constant/server-side-flags';
import { AppConfig } from '@wetransfer/transfer/core-bundle/config/app-config';
import { isValidTCString } from '@wetransfer/transfer/modules/consent-manager/tc-model';

const hasConsentFlag = (key) => AppConfig.consentFlags.includes(key);

export function isConsentFlagActive() {
  return true;
}

export function isRejectAllButtonFlagActive() {
  return hasConsentFlag(FF_REJECT_BUTTON);
}

export function isCcpaFlagActive() {
  // defaults to off,
  // on for 100% of US users
  return hasConsentFlag(FF_CCPA_BANNER);
}

export function isCcpaBannerVariantActive() {
  // return a variant of the CCPA banner
  // for IP addresses in MX, BR, and CA
  return hasConsentFlag(FF_CCPA_COOKIE_VARIANT);
}

export function isCookieWallHidden() {
  // hide the cookie wall from /pricing page in AU and NZ
  return hasConsentFlag(FF_HIDE_COOKIE_WALL);
}

export function isCookieWallDisabled() {
  // This function used to wrap an experiment evaluation for one aspect of the cookie wall
  // which is no longer in use
  // Due to an excess of references in AdTech SDK
  // we are hardcoding it to false until it can be phased out
  return false;
}

export function isConsentActivated({ user, session, consent }) {
  // Don't show GDPR wall to US users
  if (isCcpaFlagActive()) {
    return false;
  }

  if (!user || !session) {
    return true;
  }

  if (!isValidTCString(consent?.tcString)) {
    return true;
  }

  return consent?.uiVisible;
}
